/**
 *
 * @param {string} corporateClientName
 */
export const convertCorporateClientNameToReportName = corporateClientName => {
  if (!corporateClientName) return '';

  const corporateClientNameWithoutSpaces = corporateClientName.replace(/\s/g, '');

  const asciiOnlyName = corporateClientNameWithoutSpaces
    .split('')
    .filter(char => /^[\x20-\x7E]$/.test(char))
    .join('');

  var shortNameToUpper = asciiOnlyName.substring(0, 10).toUpperCase();

  return shortNameToUpper;
};
